import { type Observer, ObserverEvents } from './types';

class Observable {
	private readonly observers: Observer[] = [];

	subscribe(observer: Observer) {
		if (this.observers.some(({ event }) => event == observer.event)) return;
		this.observers.push(observer);
	}

	unsubscribe(observer: Observer) {
		const index = this.observers.findIndex(
			({ event }) => event == observer.event,
		);

		if (index === -1) return;
		this.observers.splice(index, 1);
	}

	notify(event: ObserverEvents, data?: any) {
		this.observers.forEach((observer) => {
			if (observer.event === event) observer.callback(data);
		});
	}
}

export type { Observer };
export { Observable, ObserverEvents };
